import React, { useState, useEffect } from 'react'

import { ChevronLeftIcon, PaperAirplaneIcon, ArchiveIcon } from '@primer/octicons-react'
import axios from 'axios'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'

import { REST_API } from '../../../../services/constants'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { seo } from '../../../../components/seo.component'
import authHeader from '../../../../services/auth-header'
import GemojiMenu from '../../../../components/gemoji-menu.component'
import FileManager from './shared/FileManager'

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function AdminDashboardShowTaskPage() {

    let { id, taskId } = useParams();
    let history = useHistory();
    let query = useQuery();

    const [task, setTask] = useState(null);

    const updateTaskData = async () => {
        axios({
            method: "GET",
            url: REST_API + "/api/secure/tasks/" + taskId,
            headers: await authHeader()
        }).then(response => {
            if (response.status === 200) {
                setTask(response.data);

                seo({
                    title: "Admin » " + response.data.name
                });
            } else {
                redirectToTopic();
            }
        }).catch(err => {
            redirectToTopic();
        });
    }

    const applyChangesToDatabase = async (taskName, taskConent, taskExpectsCodeSubmission, topicId) => {
        console.log("Executing Request")
        console.log("Code Submission : " + taskExpectsCodeSubmission)
        axios({
            method: "PATCH",
            url: REST_API + "/api/secure/tasks/",
            headers: await authHeader(),
            data: {
                id: taskId,
                name: taskName,
                content: taskConent,
                expectsCodeSubmission: taskExpectsCodeSubmission,
                topicId: topicId
            }
        }).then(response => {
            if (response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Änderungen gespeichert",
                    timer: 3000,
                    showConfirmButton: false
                });
            } else {
                notifySavingError(undefined);
            }
        }).catch(err => {
            notifySavingError(err);
        });
    }

    const notifySavingError = (err) => {
        Swal.fire({
            icon: "error",
            title: "Unerwarteter Fehler",
            text: "Es ist ein unerwarteter Speicherfehler aufgetreten. Die Änderungen wurden nicht übernommen.\n\n" + (err != undefined && err.response != undefined ? "Fehler Code: " + err.response.status : null)
        });
    }

    const saveTask = (shouldRedirect) => {
        console.log(task)
        applyChangesToDatabase(task.name, task.content, task.expectsCodeSubmission, task.topicId);
        if (shouldRedirect) {
            redirectToTopic();
        }
    }

    const redirectToTopic = () => {
        history.push("/admin-dashboard/topics/" + id + "/");
    }

    useEffect(() => {
        updateTaskData();
    }, [])

    const toggleExpectsCodeSubmission = () => {
        setTask({...task, expectsCodeSubmission: !task?.expectsCodeSubmission});
    }

    return (
        <>
            <Card className="mt-4">
                <Card.Header>
                    <Button onClick={() => redirectToTopic()} className="mr-4 py-2"><ChevronLeftIcon/>Zurück</Button>Aufgabe bearbeiten
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Form.Group controlId="formBasicUsername">
                            <Form.Label>Titel</Form.Label>
                            <Form.Control
                                value={task ? task.name : ""}
                                type="text"
                                placeholder="Ein Titel"
                                onChange={(e) => setTask({...task, name: e.target.value})} />
                        </Form.Group>
                        <Form.Group controlId="formTaskDescription">
                            <Form.Label>Beschreibung</Form.Label>
                            <Form.Control
                                value={task ? task.content : ""}
                                as="textarea"
                                rows="10"
                                style={{overflowX: 'clip'}}
                                placeholder="Eine treffende Beschreibung. Markdown wird unterstützt"
                                onChange={(e) => setTask({...task, content: e.target.value})}></Form.Control>
                        </Form.Group>
                        <Link to="/documentation/markdown/" target="_blank" rel="noreferrer">Markdown Cheatsheet</Link>
                    </Form>

                    <Row className="mt-4">
                        <Col sm={12} md={6} lg={6}>
                            <b>Dateien verwalten</b>
                            <FileManager taskId={taskId} />
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                            <b>Emojis hinzufügen</b>
                            <GemojiMenu onEmojiClick={(x) => setTask({...task, content: task.content + x + ' '})} />
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <Form.Check checked={task?.expectsCodeSubmission} onClick={() => toggleExpectsCodeSubmission()} disabled type="switch" label={<span style={{ textDecoration: "line-through", color: "gray" }}>Code Abgabe</span>} id="custom-switch-code-delivery" />
                    <p>Achtung! Die Code Abgabe wurde bei der Migration in die Cloud nicht übernommen und ist somit nicht mehr verfügbar.</p>
                    <br/>

                    <Button onClick={() => saveTask(false)} variant="success" className="mr-2 mb-2"><ArchiveIcon size={16} className="mr-2"/>Speichern</Button>
                    <Button onClick={() => saveTask(true)} variant="success" className="mb-2"><PaperAirplaneIcon size={16} className="mr-2"/>Speichern und verlassen</Button>

                    {
                        query.get('referrer') &&
                        <Link to={query.get('referrer')} className="btn btn-secondary ml-2">Zu vorheriger Seite gehen</Link>
                    }
                </Card.Footer>
            </Card>
        </>
    )
}